import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../services/profile.service';
import { Observable } from 'rxjs/Observable'

import { IMyDpOptions, IMyDateModel, IMyDate } from 'mydatepicker';


@Component({
    selector: 'game-history-form',
    templateUrl: './game-history-form.component.html',
    styleUrls: ['./game-history-form.component.css']
})

export class GameHistoryFormComponent implements OnInit {

    public gameHistory: Observable<Array<object>>;
    public startDate;
    public endDate;
    public selectDatesError = false;
    public wrongDatesError = false;
    public selDate: IMyDate = { year: 0, month: 0, day: 0 };


    constructor(private profileService: ProfileService) {
    }

    myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'yyyy-mm-dd',
        showTodayBtn: true,
        editableDateField: false,
        openSelectorOnInputClick: true,
    };
    ngOnInit() {
        setTimeout(() => {
            let d: Date = new Date();
            this.selDate = {
                year: d.getFullYear(),
                month: d.getMonth() + 1,
                day: d.getDate()
            };
        },0)
    }

    getGameHistory() {
        if (!this.startDate || !this.endDate) {
            return this.selectDatesError = true;
        }
        if (this.startDate.epoc > this.endDate.epoc) {
            return this.wrongDatesError = true;
        }
        let startDate = this.startDate.formatted;
        let endDate = this.endDate.formatted;
        this.selectDatesError = false;
        this.wrongDatesError = false;
        this.gameHistory = this.profileService.getGameHistory(startDate, endDate)
    }

   

}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/game-history-form/game-history-form.component.ts